module.exports = __webpack_public_path__ + "img/logoUser.d81635e5.png";